import { apiRequest } from "./apiUtils";
import {
  SpendingsResponseSchema,
  EarningsResponseSchema,
} from "@/schemas/payment";
import type {
  PaymentListResponse,
  SpendingsResponse,
  EarningsResponse,
} from "@/schemas/payment";
// Fetch payment summaries for sidebar and summary cards
// Worker summary
export async function fetchEarningsSummary({
  page = 0,
  page_size = 20,
  start_date,
  end_date,
}: {
  page?: number;
  page_size?: number;
  start_date?: string;
  end_date?: string;
} = {}): Promise<EarningsResponse> {
  const response: any = await apiRequest("payments/earnings", {
    method: "POST",
    body: JSON.stringify({ page, page_size, start_date, end_date }),
  });
  return EarningsResponseSchema.parse(response);
}

// Employer summary
export async function fetchSpendingsSummary({
  page = 0,
  page_size = 20,
  start_date,
  end_date,
}: {
  page?: number;
  page_size?: number;
  start_date?: string;
  end_date?: string;
} = {}): Promise<SpendingsResponse> {
  const response: any = await apiRequest("payments/spendings", {
    method: "POST",
    body: JSON.stringify({ page, page_size, start_date, end_date }),
  });
  return SpendingsResponseSchema.parse(response);
}

// Worker payments with assignments
export async function fetchWorkerPayments(_params: {
  workerId: string;
  start?: string;
  end?: string;
  status?: string;
}): Promise<PaymentListResponse> {
  const response: any = await apiRequest("payments/worker/payments", {
    method: "POST",
    body: JSON.stringify({ start: _params.start, end: _params.end }),
  });
  return {
    payments: response.payments || [],
    assignments: response.assignments || [],
    summary: response.summary || {},
  };
}

// Employer payments with assignments
export async function fetchBusinessPayments(_params: {
  businessId: string;
  start?: string;
  end?: string;
  status?: string;
}): Promise<PaymentListResponse> {
  const response: any = await apiRequest("payments/business/payments", {
    method: "POST",
    body: JSON.stringify({ start: _params.start, end: _params.end }),
  });
  return {
    payments: response.payments || [],
    summary: response.summary || {},
  };
}
